// Pure decisions of the inline row-rename flow (inlineRename.tsx) — split
// out so they stay testable in the node test environment.

export type RenamePhase = "idle" | "saving" | "failed";

// What an EXTERNAL rename (the dropped source's seed naming the draft
// after its collection) does to the row's naming input: a hands-off open
// closes onto the new name — its stale default would otherwise flag red
// against it — while a focused edit or an in-flight save keeps the input.
export function externalRenameAction(
  open: boolean,
  focusOpen: boolean,
  phase: RenamePhase,
): "close" | "keep" {
  if (!open || focusOpen || phase !== "idle") return "keep";
  return "close";
}
